import { useEffect, useState } from "react";
import esclip1 from "../../assets/imgs/homepage/Ellipse 154.png";
import esclip from "../../assets/imgs/homepage/Ellipse 155.png";
import logoSolution from "../../assets/imgs/soundbox/Group-156284.png.png";

import sound from "../../assets/svgs/apibanking/apibanking.svg";
import bankacc from "../../assets/svgs/apibanking/bank.svg";
import checkhow from "../../assets/svgs/apibanking/check.svg";
import esay from "../../assets/svgs/apibanking/easy.svg";
import soundbox from "../../assets/svgs/apibanking/header.svg";
import recon from "../../assets/svgs/apibanking/recon.svg";
import frequent from "../../assets/svgs/frenquent.svg";
import payment from "../../assets/svgs/payment.svg";
import poor from "../../assets/svgs/poor.svg";

import banksta from "../../assets/svgs/apibanking/bankstate.svg";
import balance from "../../assets/svgs/apibanking/blacee.svg";
import bulk from "../../assets/svgs/apibanking/bulk.svg";

import cafe from "../../assets/svgs/apibanking/api.svg";
import cafehrer from "../../assets/svgs/apibanking/customer.svg";

import { useIntersectionObserver, useWindowSize } from "@uidotdev/usehooks";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import online from "../../assets/svgs/apibanking/connect.svg";
import retail from "../../assets/svgs/apibanking/eas.svg";
import check from "../../assets/svgs/check.svg";
import { AccordionComponent } from "../../components/accordions";
import { ButtonNumber, LeafButton } from "../../components/buttons";
import { Contact } from "../../components/contact/Contact";
import { SliderDotBankingApi } from "../../components/slicksdiler";
import {
  HaveALookItem,
  SolutionItem,
  SoundBoxWorkItem,
} from "../../components/soundboxwork";
import { UpiSoundboxItem } from "../../components/upisoundbox/UpiSoundboxItem";
export const BankingApi = () => {
  const { width } = useWindowSize();
  const { t, i18n } = useTranslation();

  const [currentTitle, setCurrentTitle] = useState(t("apibanking.onboarding"));
  const [currentHeader, setCurrentHeader] = useState(
    t("apibanking.onboardingdes"),
  );
  const handleButtonClick1 = () => {
    setCurrentTitle(t("apibanking.onboarding"));
    setCurrentHeader(t("apibanking.onboardingdes"));
  };

  const handleButtonClick2 = () => {
    setCurrentTitle(t("apibanking.core"));
    setCurrentHeader(t("apibanking.coredes"));
  };
  const handleButtonClick3 = () => {
    setCurrentTitle(t("apibanking.smooth"));
    setCurrentHeader(t("apibanking.smoothdes"));
  };
  const handleButtonClick4 = () => {
    setCurrentTitle(t("apibanking.round"));
    setCurrentHeader(t("apibanking.rounddes"));
  };
  const handleButtonClick5 = () => {
    setCurrentTitle(t("apibanking.easing"));
    setCurrentHeader(t("apibanking.easingdes"));
  };
  useEffect(() => {
    if (activeButton == 1) {
      setCurrentTitle(t("apibanking.onboarding"));
      setCurrentHeader(t("apibanking.onboardingdes"));
    } else if (activeButton == 2) {
      setCurrentTitle(t("apibanking.core"));
      setCurrentHeader(t("apibanking.coredes"));
    } else if (activeButton == 3) {
      setCurrentTitle(t("apibanking.smooth"));
      setCurrentHeader(t("apibanking.smoothdes"));
    } else if (activeButton == 4) {
      setCurrentTitle(t("apibanking.round"));
      setCurrentHeader(t("apibanking.rounddes"));
    } else {
      setCurrentTitle(t("apibanking.easing"));
      setCurrentHeader(t("apibanking.easingdes"));
    }
  }, [t]);

  const [activeButton, setActiveButton] = useState(1); // State để theo dõi nút hiện đang được kích hoạt

  const handleButtonClick = (buttonNumber) => {
    setActiveButton(buttonNumber); // Cập nhật state để chỉ định nút được kích hoạt
  };
  const [ref, entry] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref1, entry1] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });
  const [ref2, entry2] = useIntersectionObserver({
    threshold: 0,
    root: null,
    rootMargin: "0px",
  });

  const [isVisible, setIsVisible] = useState(false);
  const [isVisible1, setIsVisible1] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  useEffect(() => {
    if (entry && entry.isIntersecting && !isVisible) {
      setIsVisible(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry, isVisible]);
  useEffect(() => {
    if (entry1 && entry1.isIntersecting && !isVisible1) {
      setIsVisible1(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry1, isVisible1]);
  useEffect(() => {
    if (entry2 && entry2.isIntersecting && !isVisible2) {
      setIsVisible2(true); // Đánh dấu đã gặp isIntersecting
    }
  }, [entry2, isVisible2]);

  return (
    <div className="relative mt-[145px]">
      <Helmet>
        <title>{t("footer.api")} | Trusted Pay</title>
      </Helmet>
      <img className="absolute left-0 top-[0]" src={esclip} alt="" />
      <img className="absolute right-0 top-[0]" src={esclip1} alt="" />
      <div className="absolute left-[50%] top-[50px] h-[24px] w-[24px] animate-movesquare rounded-[24px] bg-[#FF9B26]"></div>
      <div className="absolute left-[40%] top-[450px] h-[42px] w-[39px] animate-movesquare-slow rounded-[24px] bg-[#565ADD]"></div>

      {/* SOUNDBOX */}
      <div className="relative mx-auto max-w-[1280px] px-4 mothaibaysaimin:px-8">
        {width > 1024 ? (
          <div className="flex items-center gap-[30px] sm:flex-col">
            <div className="max-w-[625px] ">
              <p className="animate-fadeInDown text-[40px] font-bold text-[--color-text]">
                {t("apibanking.header")}
              </p>
              <div className="animate-fadeInUp">
                <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text] ">
                  {t("apibanking.headerdes")}
                </p>
                <LeafButton
                  title={t("apibanking.contactsale")}
                  style={{ marginTop: "36px" }}
                />
              </div>
            </div>
            <div className="relative">
              <img
                className="h-[500px] w-[606px] animate-fadeInDown sm:h-[350px] sm:w-[450px] lg:h-[400px] lg:w-[500px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 left-1/3 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex animate-fadeInDown items-center gap-[30px] sm:flex-col">
            <div className="relative">
              <img
                className="h-[500px] w-[606px] lg:w-[500px] lgmax:h-[400px]"
                src={soundbox}
                alt=""
              />
              <div className="absolute top-0 -z-10">
                <div className="absolute left-0 top-[-20px] h-[500px] w-[500px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#FF9B26]"></div>
                </div>
                <div className="absolute left-[40px] top-[16px] h-[420px] w-[420px] rounded-[50%] border border-solid border-blue-200"></div>
                <div className="absolute left-[80px] top-[52px] h-[340px] w-[340px] animate-spin rounded-[50%] border border-solid border-blue-200">
                  <div className="absolute left-[200px] top-[-5px] h-[14px] w-[14px] rounded-[50%] bg-[#565ADD]"></div>
                </div>
                <div className="absolute left-[120px] top-[82px] h-[260px] w-[260px] rounded-[50%] border border-solid border-blue-200"></div>
              </div>
            </div>

            <div className="max-w-[625px]">
              <p className="text-[40px] font-bold text-[--color-text] ">
                {t("apibanking.header")}
              </p>
              <p className="text-4 mt-[20px] max-w-[625px] font-semibold text-[--color-text]">
                {t("apibanking.headerdes")}
              </p>
              <LeafButton
                title={t("apibanking.contactsale")}
                style={{ marginTop: "36px" }}
              />
            </div>
          </div>
        )}
      </div>
      <div ref={ref}>
        <div
          className={`relative mx-auto max-w-[1280px] md:px-[80px] py-[50px] px-4  ${isVisible ? "animate-fadeInUp" : null}`}
        >
          <div className="flex flex-col items-center justify-center gap-[20px]">
            <div className="group">
              <img
                src={sound}
                alt=""
                className=" animate-spin  transition-all group-hover:animate-hover"
              />
            </div>

            <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[--color-title]">
              {t("apibanking.under")}{" "}
              <span className="text-[--color-hover]">
                {t("apibanking.apibanking")}
              </span>
            </h1>
            <p className="text-4 max-w-[780px] text-center font-montserrat text-[--color-text]">
              {t("apibanking.underdes")}
            </p>
          </div>
        </div>
      </div>

      <div ref={ref1}>
        <div
          className={`rounded-tr-[200px] bg-[#EFF0FF] sm:rounded-tl-[50px] sm:rounded-tr-[50px] ${isVisible1 ? "animate-fadeInUp" : null}`}
        >
          <div className="mx-auto flex max-w-[1280px] flex-col gap-[20px] px-[50px] py-[50px] sm:px-4">
            <h1 className="max-w-[1240px] text-center text-[36px] font-bold text-[--color-title]">
              {t("apibanking.howdoes")}{" "}
              <span className="text-[--color-hover]">
                {t("apibanking.bankingwork")}{" "}
              </span>
            </h1>
            <div className="flex lgmax:flex-wrap lgmax:justify-center">
              <SoundBoxWorkItem
                image={esay}
                titleheader={t("apibanking.easy")}
                title={t("apibanking.easydes")}
              />
              <SoundBoxWorkItem
                image={bankacc}
                titleheader={t("apibanking.bankacc")}
                title={t("apibanking.bankaccdes")}
              />
              <SoundBoxWorkItem
                image={checkhow}
                titleheader={t("apibanking.check")}
                title={t("apibanking.checkdes")}
              />
              <SoundBoxWorkItem
                image={recon}
                titleheader={t("apibanking.recon")}
                title={t("apibanking.recondes")}
              />
            </div>
          </div>
        </div>
      </div>

      <div ref={ref2}>
        <div
          className={`relative min-h-[570px] bg-soundbox bg-cover bg-center bg-no-repeat sm:h-full   ${isVisible2 ? "animate-fadeInUp" : null}`}
        >
          <div
            className={`absolute bottom-0 left-0 right-0 top-0 min-h-[570px] bg-soundboxOverlay opacity-[0.63]
                sm:h-full `}
          ></div>
          <div className="left-26 absolute z-[100] h-0 w-48 border-dashed  border-white bg-white"></div>
          <div
            className={`relative  mx-auto max-w-[1280px] px-4 pb-[12px] pt-[70px]`}
          >
            <div>
              <h1 className="max-w-[1240px]  text-center text-[36px] font-bold text-[#fff]">
                {t("apibanking.proplem")}{" "}
                <span className="text-[--color-hover]">
                  {t("apibanking.without")}
                </span>{" "}
              </h1>
              <div>
                <div className="absolute left-[17%] top-[32.5%]  w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="absolute left-[17%] top-[33.05%] w-[65%] border-[1px] border-dashed border-white sm:hidden"></div>
                <div className="relative flex sm:flex-col sm:items-center sm:justify-center sm460:gap-[30px] ">
                  <UpiSoundboxItem
                    image={payment}
                    titleheader={t("apibanking.tiring")}
                    title={t("apibanking.tiringdes")}
                    height={"lgmin:min-h-[360px]"}
                  />
                  <UpiSoundboxItem
                    image={frequent}
                    titleheader={t("apibanking.slow")}
                    title={t("apibanking.slowdes")}
                    height={"lgmin:min-h-[360px]"}
                  />
                  <UpiSoundboxItem
                    image={poor}
                    titleheader={t("apibanking.time")}
                    title={t("apibanking.timedes")}
                    height={"lgmin:min-h-[360px]"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-[640px] bg-[#EFF0FF] sm:min-h-[740px] lg:min-h-[580px]">
        <div className="mx-auto max-w-[1400px] flex-col gap-[20px] px-[50px]  py-[50px] sm:px-[16px]">
          <h1 className="ml-[30px] max-w-[1240px] text-center text-[36px] font-bold text-[--color-title] sm:ml-0">
            {t("apibanking.bref")}{" "}
            <span className="text-[--color-hover]">
              {t("apibanking.bankingapi")}{" "}
            </span>
          </h1>
          <SliderDotBankingApi />
        </div>
      </div>

      <div className="relative bg-white ">
        <div
          className={`mx-auto flex max-w-[1280px] items-center justify-center px-4 py-[50px] pt-[50px]  sm:flex-wrap lg:flex-wrap`}
        >
          <div className="relative max-w-[640px]">
            <img className="lgmax:w-[560px]" src={logoSolution} alt="" />{" "}
          </div>
          <div className="ml-[60px] sm:ml-0 lgmax:ml-0">
            <h1 className="max-w-[620px]  text-[36px] font-bold text-[--color-title]">
              {i18n.language === "vi" ? (
                <>
                  {t("apibanking.here")}
                  <span className="text-[--color-hover]">
                    {t("apibanking.potental2")}
                  </span>
                  {t("apibanking.here2")}
                </>
              ) : (
                <>
                  {t("apibanking.here")}
                  <span className="text-[--color-hover]">
                    {t("apibanking.potental")}
                  </span>
                </>
              )}
            </h1>
            {}

            <HaveALookItem
              image={cafe}
              titleheader={t("apibanking.autome")}
              title={t("apibanking.auromedes")}
              bottomValue={"bottom-[16px]"}
              paddingleft={"pl-[16px]"}
            />

            <HaveALookItem
              image={cafehrer}
              titleheader={t("apibanking.customerhere")}
              title={t("apibanking.customerheredes")}
              bottomValue={"bottom-[16px]"}
              paddingleft={"pl-[16px]"}
            />

            <HaveALookItem
              image={retail}
              titleheader={t("apibanking.easyhere")}
              title={t("apibanking.easyheredes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[40px]" : "bottom-[16px]"
              }
              paddingleft={"pl-[16px]"}
            />

            <HaveALookItem
              image={online}
              titleheader={t("apibanking.connect")}
              title={t("apibanking.connectdes")}
              bottomValue={
                i18n.language === "en" ? "bottom-[-10px]" : "bottom-[-10px]"
              }
              paddingleft={"pl-[16px]"}
            />
          </div>
        </div>
      </div>
      <div className="rounded-t-3xl bg-pupletowhite">
        <div className="mx-auto max-w-[1280px] flex-col justify-between px-4 py-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <h1 className="ml-[30px] pb-[15px] text-[36px] font-bold text-white sm:ml-0">
            {t("apibanking.trustpay")}
            <span className="text-[#D1D1F7]">{t("apibanking.allin")}</span>
          </h1>
          <p className="text-4 ml-[30px] text-white sm:ml-0">
            {t("apibanking.allindes")}
          </p>
          <div className="ml-[30px] mt-[20px] flex sm:ml-0 lgmax:flex-col lgmax:gap-[30px]">
            <SolutionItem
              image={banksta}
              titleheader={t("apibanking.banktrus")}
              title={t("apibanking.banktrusdes")}
            />
            <SolutionItem
              image={balance}
              titleheader={t("apibanking.blantrus")}
              title={t("apibanking.blantrusdes")}
            />
            <SolutionItem
              image={bulk}
              titleheader={t("apibanking.bulktrus")}
              title={t("apibanking.bulktrusdes")}
            />
            <SolutionItem
              image={bulk}
              titleheader={t("apibanking.vendor")}
              title={t("apibanking.vendordes")}
            />
          </div>
        </div>
      </div>

      <div className="bg-white sm:py-[50px]">
        <div className="mx-auto flex max-w-[1280px] justify-between px-4 py-[50px] pt-[50px] sm:py-0 lgmaxmin:flex-col lgmaxmin:items-center">
          <div className={`mr-[10px] flex flex-1 flex-col gap-[20px]`}>
            <h1 className="max-w-[520px] text-[36px] font-bold  text-[--color-title] lgmaxmin:max-w-[850px]">
              {t("apibanking.whydes1")}
              <span className="text-[--color-hover]">
                {t("apibanking.apibanking")}
              </span>
              ?
            </h1>
            <p className="text-4 max-w-[620px] font-montserrat text-[#3D2E7C] lgmaxmin:max-w-[850px]">
              {t("apibanking.whychoosedes3")}
              <a href="#" className=" text-[#565ADD] hover:underline">
                {t("apibanking.whychoosedes4")}
              </a>
              {t("apibanking.whychoosedes")}
            </p>
            <p className="text-4 max-w-[620px] font-montserrat text-[#3D2E7C] lgmaxmin:max-w-[850px]">
              {t("apibanking.whychoosedes2")}
            </p>
            <div className="group flex items-start gap-[30px] p-4 sm:flex-col sm:items-center">
              <img
                className="group-hover:animate-hover sm:h-[43px] sm:w-[43px]"
                src={check}
                alt=""
              />
              <div className="sm:text-center">
                <p className="border-b-solid inline-block border-b-4 border-b-[#f1f1f1] pb-[12px] text-[24px] font-bold text-[#333]">
                  {currentTitle}
                </p>

                <p className="text-4 mt-[10px]  font-normal text-[#3D2E7C] lg:max-w-[650px]">
                  {currentHeader}
                </p>
              </div>
            </div>
            <div className="flex gap-[30px] sm:gap-1 items-center">
              <ButtonNumber
                title={"1"}
                onClick={() => {
                  handleButtonClick1();
                  handleButtonClick(1);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 1}
              />
              <ButtonNumber
                title={"2"}
                onClick={() => {
                  handleButtonClick2();
                  handleButtonClick(2);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 2}
              />
              <ButtonNumber
                title={"3"}
                onClick={() => {
                  handleButtonClick3();
                  handleButtonClick(3);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 3}
              />
              <ButtonNumber
                title={"4"}
                onClick={() => {
                  handleButtonClick4();
                  handleButtonClick(4);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 4}
              />
              <ButtonNumber
                title={"5"}
                onClick={() => {
                  handleButtonClick5();
                  handleButtonClick(5);
                }} // Gọi hai hàm xử lý sự kiện
                isActive={activeButton === 5}
              />
            </div>
          </div>
          <div className="flex flex-1 flex-col gap-[20px]  lg:mt-[20px] lgmax:mt-[20px]">
            <h1 className="max-w-[520px] text-[36px] font-bold text-[--color-title]">
              FA<span className="text-[--color-hover]">Q's</span>
            </h1>
            <AccordionComponent
              header1={t("apibanking.why")}
              des1={t("apibanking.whydes")}
              header2={t("apibanking.howlong")}
              des2={t("apibanking.howlongdes")}
              header3={t("apibanking.canmy")}
              des3={t("apibanking.canmydes")}
              header4={t("apibanking.canyou")}
              des4={t("apibanking.canyoudes")}
              header5={t("apibanking.howwill")}
              des5={t("apibanking.howwilldes")}
              check={true}
            />
          </div>
        </div>
      </div>

      <Contact
        header={t("apibanking.contact")}
        headertitle={t("apibanking.withus")}
        headerdes={t("apibanking.wiusdes")}
      />
    </div>
  );
};
